import PolicyLayout from "@/components/site/PolicyLayout";
import Seo from "@/components/site/Seo";
import { BUSINESS } from "@/lib/siteData";

export default function Privacy() {
  return (
    <PolicyLayout title="Privacy Policy" lastUpdated="January 2026" testId="privacy-page">
      <Seo
        title="Privacy Policy"
        description="How Repair Point collects, uses, and protects your personal data. GDPR-aligned data handling, 30-day deletion rights and zero data sales."
        path="/privacy"
      />
      <h2 className="font-heading text-xl font-semibold">1. Who we are</h2>
      <p>
        {BUSINESS.name} (&ldquo;we&rdquo;, &ldquo;our&rdquo;, &ldquo;us&rdquo;) is an independent
        remote-only computer support service for U.S. customers. Our registered office is
        {" "}{BUSINESS.registeredAddress} and our operations centre is at {BUSINESS.operationsAddress}.
        We can be reached at {BUSINESS.email} or {BUSINESS.phone}.
      </p>

      <h2 className="font-heading text-xl font-semibold">2. What we collect</h2>
      <p>
        When you submit our contact form we collect your name, email address, phone number, the device type
        you own and a description of the issue. We collect this information solely to respond to your enquiry
        and provide a written quote.
      </p>

      <h2 className="font-heading text-xl font-semibold">3. How we use your information</h2>
      <ul className="list-disc pl-6 space-y-1.5">
        <li>To contact you about your enquiry and provide a written diagnostic.</li>
        <li>To schedule and deliver the repair service you request.</li>
        <li>To send essential service updates (e.g. parts arrival, repair status).</li>
      </ul>
      <p>
        We do <strong>not</strong> sell or rent your personal data and we do not send marketing emails without
        a separate opt-in.
      </p>

      <h2 className="font-heading text-xl font-semibold">4. Data on your device</h2>
      <p>
        Your files and personal data remain on your device. Technicians only access data when strictly required
        to complete the repair and never copy personal data off your machine without your written permission.
      </p>

      <h2 className="font-heading text-xl font-semibold">5. Retention</h2>
      <p>
        Enquiry records are kept for up to 24 months for warranty and accounting purposes, after which they are
        deleted or anonymised.
      </p>

      <h2 className="font-heading text-xl font-semibold">6. Your rights</h2>
      <p>
        You may request access to, correction of, or deletion of your personal information at any time by
        emailing {BUSINESS.email}. We will respond within 30 days.
      </p>

      <h2 className="font-heading text-xl font-semibold">7. Cookies</h2>
      <p>
        This website uses only essential cookies required for the contact form and analytics. No advertising or
        cross-site tracking cookies are placed.
      </p>

      <h2 className="font-heading text-xl font-semibold">8. Independent service disclaimer</h2>
      <p>
        {BUSINESS.name} is not affiliated with, endorsed by, or sponsored by Microsoft Corporation, Apple Inc.,
        or any other brand referenced on this site.
      </p>
    </PolicyLayout>
  );
}
